import { RefObject, useEffect, useState } from "react";
import useMeasure from "react-use-measure";
import { useScreenWidth } from "./useScreenWidth";

const useCountItemsInBlock = ({
  itemRef,
  gapHeight,
  minCount
}: {
  itemRef: RefObject<HTMLElement>;
  gapHeight: number;
  minCount?: number;
}) => {
  const { isMobile } = useScreenWidth();
  const [ref, { height }] = useMeasure();
  const [maxItemCount, setMaxItemCount] = useState(5);

  useEffect(() => {
    if (!itemRef || !itemRef.current || !height) return;

    const itemHeight = itemRef.current.clientHeight;
    const maxCountItemsWithoutGaps = Math.floor(height / itemHeight);
    const countGaps = maxCountItemsWithoutGaps;
    const maxCountItems = Math.floor((height - countGaps * gapHeight) / itemHeight);

    setMaxItemCount(maxCountItems > Number(minCount) || isMobile ? maxCountItems : Number(minCount));
  }, [height, itemRef.current]);

  return {
    ref,
    maxItemCount
  };
};

export default useCountItemsInBlock;